<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XJSht8/tc-custom/9780674973770.jpg?1701477035670" alt="This image is the cover for the book Marvellous Thieves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marvellous Thieves
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fascinating work of cultural and literary history . . . An insightful examination of [the <i>Arabian Nights</i>] and the fraught complexities of translation.” —<i>Kirkus Reviews</i></b><br/><br/>Although many of its stories originated centuries ago in the Middle East, the <i>Arabian Nights</i> is regarded as a classic of world literature by virtue of the seminal French and English translations produced in the eighteenth and nineteenth centuries. Supporting the suspicion that the story collection is more Parisian than Persian, some of its most famous tales, including the stories of Aladdin and Ali Baba, appear nowhere in the original sources. Yet as befits a world where magic lamps may conceal a jinni and fabulous treasures lie just beyond secret doors, the truth of the <i>Arabian Nights</i> is richer than standard criticism suggests.<br/><br/>“<i>Marvellous Thieves</i>, which draws on hitherto neglected sources, is a brilliant, fluent and original work of literary scholarship.” —Robert Irwin, <i>Literary Review</i><br/><br/>“This fine book . . . cogently probes an influential period in the knotted and at times sordid history of the <i>Arabian Nights</i>, serving as a fine example to those unraveling this promiscuous and forever malleable set of stories.” —Charles Shafaieh, <i>Wall Street Journal</i><br/><br/>“Intelligent and engrossing . . . The great merit of Horta’s book is that its interest always lies in the story of the story, in mapping out the complex network of the translators, editors and travellers behind the <i>Arabian Nights</i>, in ways that enrich our sense of this remarkable text.” —Shahidha Bari, <i>Times Higher Education</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paulo Lemos Horta
      </h2>
      
      <p class="authorDescription body article">Paulo Lemos Horta is Assistant Professor of Literature at New York University Abu Dhabi.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?643fe196